import { render, staticRenderFns } from "./DiscountedInternetOfferTile.vue?vue&type=template&id=3abc56fa&scoped=true"
import script from "./DiscountedInternetOfferTile.vue?vue&type=script&lang=js"
export * from "./DiscountedInternetOfferTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc56fa",
  null
  
)

export default component.exports